export const GDS_CREDENTIALS_ENDPOINT_KEY = 'gds-credentials'
